import useDocumentTitle from '../hooks/useDocument';
import {Link} from 'react-router-dom';
import Header from '../components/header';
import Breadcrumb from '../components/breadcrumb';
import Features from '../components/features';
import CallToAction from '../components/calltoaction';
import Footer from '../components/footer';

function WhoWeWorkWithView() {
  useDocumentTitle('Who we work with-Quality-Home-Healthcare');
  return (
    <div className="body-wrapper">
      <Header />
      <Breadcrumb
        image={'bg-image-10'}
        title={'Who We Work With'}
        link={'Who We Work With'}
      />

      <div className="ltn__page-details-area ltn__service-details-area mb-105">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <h2 className="text-left compassion">People we work with</h2>
              <div className="ltn__page-details-inner ltn__service-details-inner">
                <p className="values_p">
                  {' '}
                  <span className="ltn__first-letter">W</span>e provide personal
                  and complex healthcare services in the home for local
                  integrated care boards (ICBs), case managers, local
                  authorities, and private clients and their families across
                  Worcestershire, UK.
                </p>
                <p className="values_p3">
                  We work closely with our clients, their families, funding
                  bodies, and legal representatives as we offer personal and
                  complex care services that help people with life-limiting and
                  long-term conditions live as independently as possible and
                  achieve their aspirations..
                </p>
                <p className="values_p3">
                  We have a vibrant governance and policy framework that ensures
                  that our nurse-led care is safely provided, not just to high
                  standards but also in compliance with regulations. Through
                  these high standards, we are able to keep track of our care
                  services. We can also respond quickly and effectively to
                  guidance and feedback, ensuring that we continue to put our
                  clients and our standards of service for them at the center of
                  all we do.
                </p>
              </div>
            </div>
            <div className="col-lg-4">
              <aside className="sidebar-area ltn__right-sidebar">
                <h2 className="text-center compassion">Also see:</h2>
                <div className="widget-2 ltn__menu-widget ltn__menu-widget-2 text-uppercase">
                  <ul>
                    <li>
                      <Link to="/funding">
                        Funding your care
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li className="">
                      <Link to="/excellence">
                        Quality and clinical excellence
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/team">
                        Meet our team
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/stories">
                        Real stories
                        <span>
                          <i className="fas fa-arrow-right"></i>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">
                  Our Dedicated local hubs and teams
                </h2>
                <p className="white-color">
                  Our dedicated and experienced local teams ensure that we
                  consistently deliver excellent personal and complex home
                  healthcare services that are focused on our clients’ clinical,
                  personal, and social needs.
                </p>
                <p className="white-color">
                  Our local operational hubs located across Worcestershire as
                  well as our central office team, enable us to offer versatile,
                  local, and personalized complex healthcare services that meet
                  the needs of our clients.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Combining skills, expertise, and knowledge to offer excellent
                  care services
                </h2>
                <p className="">
                  Our goal has always been to provide a specialist home care
                  service to those with life-limiting and complex needs.Thus, we
                  deliver excellent care using the skills, expertise, and
                  knowledge of our team to offer the highest standards of
                  person-centered care at home.
                </p>
                <p>
                  We have a vibrant governance and policy framework that ensures
                  that our nurse-led care is safely provided, not just to high
                  standards but also in compliance with regulations. Through
                  these high standards, we are able to keep track of our care
                  services. We can also respond quickly and effectively to
                  guidance and feedback, ensuring that we continue to put our
                  clients and our standards of service for them at the center of
                  all we do.
                </p>
                <p>
                  Quality Health and Homecare services are rooted in ‘the 6 Cs’,
                  a set of values upheld by the NHS for all health and social
                  care staff. The 6 Cs are the platform upon which care is
                  delivered to all our clients. Thus, our care is always
                  person-centered and safe.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 compassion-bg pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Commissioners</h2>
                <p className="white-color">
                  We have strong relationships and partnerships with all the
                  commissioners in the locations where we work. We currently
                  work with over 90 ICBs as well as commissioners, the NHS
                  continuing healthcare teams, community teams, commissioning
                  support units (CSUs), local authorities, children’s disability
                  teams, social workers, and private case managers. Open and
                  honest partnerships based on trust cause the best outcomes.
                </p>
                <p className="white-color">
                  We use effective and economical delivery methods to provide
                  nurse-led complex care in the home with a focus on quality and
                  clinical excellence. Instead of concentrating on our clients'
                  disabilities, our teams facilitate outcomes and lifestyle
                  options.
                </p>
                <p className="white-color">
                  We provide healthcare assistants, support staff, registered
                  nurses, and other healthcare professionals who have all been
                  specially trained to meet the unique requirements of our
                  clients as part of our complex care packages. All of our
                  employees receive ongoing training and growth, and we arrange
                  specialized training as needed.
                </p>
                <p className="white-color">
                  We presently work on spot purchases, regional framework
                  agreements, and NHS standard contracts. We also offer
                  treatment and assistance to people whose funds are direct
                  payments or Personal Health Budgets. (PHB). If you are a PHB
                  beneficiary, you can learn more about our assistance options
                  here.
                </p>
                <p className="white-color">
                  Our pricing is based on a thorough clinical evaluation, and we
                  provide care in accordance with the requirements of our
                  clients. We also provide services to Commissioners based on
                  customized weekly or yearly budgets.
                </p>
                <p className="white-color">
                  Please get in touch with our Commercial Team to talk about any
                  existing, upcoming, or ongoing care packages.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Working with Integrated Care Boards (ICBs)
                </h2>
                <p className="">
                  We are highly skilled and knowledgeable in providing
                  complicated care to people in their homes and the community.
                </p>
                <p>
                  We collaborate closely with ICBs all over England, using their
                  in-depth understanding of clinical and social issues to
                  provide all customers with high-caliber, dependable services.
                </p>
                <p>
                  We provide services to adults, kids, and teenagers who have,
                  but are not limited to, the following conditions:
                </p>
                <div>
                  <ul className="care_bullets-2">
                    <li>Brain injury</li>
                    <li className="">Spinal injury</li>
                    <li>Learning disabilities</li>
                    <li>Ventilation and airway management</li>
                    <li>Degenerative and neurological conditions</li>
                    <li>Rehabilitation</li>
                    <li>Palliative/End-of-Life Care</li>
                  </ul>
                </div>
                <p>
                  We are known for providing high levels of support to
                  commissioners of care and their service users.
                </p>
                <p>
                  Some of our clients receive dual-funded packages, either
                  privately funded, case management settlements, or personal
                  health budgets. Our services are versatile and responsive. We
                  can provide our clients with any additional support they need
                  on a short-term or long-term basis as well as assess and
                  accommodate their changing medical needs.
                </p>
                <p>
                  To discuss any current, new, or prospective care packages
                  please contact our Commercial Team.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 bg-overlay-theme-90 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="white-color">Working with Case Managers</h2>
                <p className="white-color">
                  We work with many major case management companies and personal
                  injury law firms. We provide specialist evidence-based care
                  and support packages to adults, children and young people who
                  have been injured due to accidents or medical negligence
                </p>
                <p className="white-color">
                  With local teams throughout Worcestershire, we can provide
                  quotations and arrange assessments with one of our clinical
                  nurse specialists. We have what it takes to understand the
                  needs of our clients and recommend the best care available for
                  them We also arrange bespoke training for our staff where
                  necessary..
                </p>
                <p className="white-color">
                  We always get referrals from case managers who present clients
                  with several of conditions including, but not limited to:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>Brain injury (ABI and TBI)</li>
                    <li className="">Spinal cord injury</li>
                    <li>Complex orthopaedics</li>
                    <li>Acquired injuries from birth</li>
                  </ul>
                </div>
                <p className="white-color">
                  The unique needs of every client referred to us requires
                  tailored support. In many cases, we provide care for many
                  years whilst some clients require short-term, flexible care.
                  Here are some of the broad types of care packages we provide
                  to people in their homes:
                </p>
                <div>
                  <ul className="care_bullets">
                    <li>Extensive complex healthcare packages.</li>
                    <li className="">
                      Personal assistance and social care packages.
                    </li>

                    <li>Rehabilitation support packages.</li>
                  </ul>
                </div>
                <p className="white-color">
                  We identify the best medical staff for your client by focusing
                  on their unique needs and preferences when we set up care,
                  support, and rehabilitation packages. In order to introduce
                  care in a manner that supports family life, we also
                  collaborate with the client's family members.
                </p>
                <p className="white-color">
                  As the Case Manager, we will give you timely, accurate
                  information in a format that will be simple for you to include
                  in any reports or suggestions you might be writing on behalf
                  of your clients.
                </p>
                <p className="white-color">
                  Please get in touch with our Commercial Team to talk any
                  recent, new, or potential cases.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left">
                <h2 className="compassion">
                  Personal Injury and Medical Negligence Clients
                </h2>
                <p className="">
                  At the beginning or during the litigation process, providing
                  complicated healthcare, rehabilitation, and social care
                  packages to clients who have suffered personal injuries can
                  have different needs than our more conventional continuing
                  healthcare clients.
                </p>
                <p>
                  As a result, we have designed our services especially for
                  people who have suffered personal injuries and are being
                  looked after by Case Managers and Personal Injury Deputies.
                  These services are provided throughout England under the
                  direction of our local office staff.
                </p>

                <p>
                  Please get in touch with our commercial team to talk about any
                  recent, new, or potential cases.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="call-to-action-area call-to-action-5 pt-80 pb-80">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="call-to-action-inner call-to-action-inner-5 text-decoration text-left"></div>
            </div>
          </div>
        </div>
      </div>
      <Features
        icon1="fas fa-user-nurse"
        icon2="fas fa-user-nurse"
        text1=" We specialise in the delivery of complex care in your home."
        text2="How we create your personalised complex care plan.
        "
        btn1="Our care service"
        btn2="Learn more"
      />
      <CallToAction />
      <Footer />
    </div>
  );
}

export default WhoWeWorkWithView;
